import { api } from "./axios";

export async function fetchMenus() {
  const response = await api.get("/menus/api/Menu");
  return response.data;
}
